module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/carouselArrow.da80cfee.svg";